import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";
import "core-js/modules/web.dom-collections.for-each";
import kelkoo from "web/script/embedded/kelkoo";
import environment from "web/script/modules/environment";
var ACCOUNTS = {
  UK: 100506873,
  DE: 100501708,
  US: 100501707
};
export default {
  send: function send(data) {
    var predictedRPL = environment.get("predictedTrackValue");
    var country = environment.get("country");

    if (country === "GB") {
      country = "UK";
    }

    var merchantId = ACCOUNTS[country];

    if (predictedRPL && environment.get("trafficSource") == "kelkoo" && merchantId) {
      data.forEach(function (event) {
        if (event.data.action === "lead") {
          var _data = {
            merchantInfo: [{
              country: country,
              merchantId: merchantId
            }],
            orderValue: predictedRPL,
            orderId: event.data.label
          };
          kelkoo(_data);
          return Promise.resolve();
        }
      });
    }
  }
};